export default __webpack_public_path__ + "static/media/mysql-logo.4fe76d0c.png";